module.exports = __webpack_public_path__ + "static/gsch3-8b094a8c0bbed37639df00968b3783e0.png";